import api from 'Application/api/api';

const getGeneralProjectFiles = (projectId, cancelToken = null) =>
    api.get(`project-manager/projects/${projectId}/files`, {
        cancelToken,
    });

export default getGeneralProjectFiles;
